import { createApi } from '@reduxjs/toolkit/query/react'
import ApiMiddleWare from '../api-middleware';
import { baseQueryWithHttpStatus } from '../services/baseQuery';

// Define a service using a base URL and expected endpoints
export const accountStore = createApi({
    reducerPath: 'accountStore',
    baseQuery: baseQueryWithHttpStatus,
    endpoints: (builder) => ({
        Logout: builder.mutation({
        query: (body) => {
            return {
            url: 'gptblueSecurity/logOutUser/',
            method: 'POST',
            body: {
            }
            }
        }
        }),
        getUserProfile: builder.mutation({
            query: (body) => {
            return {
                url: 'userManagerCFC/getUserProfile/',
                method: 'POST',
                body: {}
            }
            },
            onQueryStarted: async (id, { dispatch, queryFulfilled }) => { try { ApiMiddleWare(await queryFulfilled, dispatch) } catch (error: any) { } }
        }),
        postUserProfile: builder.mutation({
            query: (userPostData) => {
            return {
                url: 'userManagerCFC/updateUserProfile/',
                method: 'POST',
                body: {...userPostData}
              }
            },
            onQueryStarted: async (id, { dispatch, queryFulfilled }) => { try { ApiMiddleWare(await queryFulfilled, dispatch) } catch (error: any) { } }
        }),
        connectAccount: builder.mutation({
            query: (body) => {
              return {
                url: 'userManagerCFC/ConnectAccount/',
                method: 'POST',
                body: {...body}
              }
            },
            onQueryStarted: async (id, { dispatch, queryFulfilled }) => { try { ApiMiddleWare(await queryFulfilled, dispatch) } catch (error: any) { } }
        }),
        verifySecurityCodes: builder.mutation({
            query: (body)=>{
              return {
                url: '/userManagerCFC/verifySecurityCodes/',
                method: 'POST',
                body:{...body}
              }
            },
            onQueryStarted: async (id, { dispatch, queryFulfilled }) => { try { ApiMiddleWare(await queryFulfilled, dispatch) } catch (error: any) { } }
        }),
        resendCode: builder.mutation({
            query: () => {
              return {
                url: '/userManagerCFC/resendCode/',
                method: 'POST',
                body: {}
              }
            },
            onQueryStarted: async (id, { dispatch, queryFulfilled }) => { try { ApiMiddleWare(await queryFulfilled, dispatch) } catch (error: any) { } }
        }),
        diassociateAccount: builder.mutation({
            query: (body) => {
              return {
                url: '/userManagerCFC/DisassociateAccount/',
                method: 'POST',
               body:{...body}
              }
            },
            onQueryStarted: async (id, { dispatch, queryFulfilled }) => { try { ApiMiddleWare(await queryFulfilled, dispatch) } catch (error: any) { } }
        }),
        validateAuthToken:  builder.mutation({
            query: () => {
              return {
               url: "/gptblueSecurity/validateAuthToken/",
                method:"POST",
                body: {}
              }
            },
            onQueryStarted: async (id, { dispatch, queryFulfilled }) => { try { ApiMiddleWare(await queryFulfilled, dispatch) } catch (error: any) { } }
        }),
        updateUserSettings:  builder.mutation({
            query: (body) => {
              return {
               url: "userManagerCFC/updateUserSettings/",
                method:"POST",
                body: {...body}
              }
            },
            onQueryStarted: async (id, { dispatch, queryFulfilled }) => { try { ApiMiddleWare(await queryFulfilled, dispatch) } catch (error: any) { } }
        }),
        generateReferralId: builder.mutation({
            query: (body) => {
              return {
                url: 'userManagerCFC/generateRefKey/',
                method: 'POST',
                body: {}
              }
            },
            onQueryStarted: async (id, { dispatch, queryFulfilled }) => { try { ApiMiddleWare(await queryFulfilled, dispatch) } catch (error: any) { } }
        }),
        searchUser: builder.mutation({
            query:(body) => {
              return {
                url: "/userManagerCFC/searchUser/",
                method:"POST",
                body:{...body}
              }
            },
            onQueryStarted: async (id, { dispatch, queryFulfilled }) => { try { ApiMiddleWare(await queryFulfilled, dispatch) } catch (error: any) { } }
        }),
        getWeeklyConsumptionAll: builder.mutation({
          query:(body) => {
            return {
              url: "/ConsumptionAccountingAPI/getWeeklyConsumptionAll/",
              method:"POST",
              body:{...body}
            }
          },
        }),
        getMonthlyConsumptionAll: builder.mutation({
          query:(body) => {
            return {
              url: "/ConsumptionAccountingAPI/getMonthlyConsumptionAll/",
              method:"POST",
              body:{...body}
            }
          },
      }),
      getSessionStatus: builder.query({
        query: (body) => {
          return {
            url: "/gptblueSecurity/getSessionStatus/",
            method: "GET",
            params: body
          }
        },
      }),
    })
});
export const {
    useLogoutMutation,
    useGetUserProfileMutation,
    usePostUserProfileMutation,
    useConnectAccountMutation,
    useVerifySecurityCodesMutation,
    useResendCodeMutation,
    useDiassociateAccountMutation,
    useValidateAuthTokenMutation,
    useUpdateUserSettingsMutation,
    useGenerateReferralIdMutation,
    useSearchUserMutation,
    useGetWeeklyConsumptionAllMutation,
    useGetMonthlyConsumptionAllMutation,
    useLazyGetSessionStatusQuery,
    useGetSessionStatusQuery,
} = accountStore;